import { action, observable } from 'mobx';

import { BaseGlobalEntityStore } from './base-global-entity.store';
import { Account } from '~/models/account.model';
import type { IAccountResponse } from '~/types/server.types';
import type { AuthenticatedGlobalContextValue } from '~/providers/base-global-context/authenticated-global.context';

export class AccountStore extends BaseGlobalEntityStore<
    IAccountResponse,
    Account
> {
    @observable isFeaturePlanLoading = false;
    @observable hasLoadedFeaturePlan = false;
    @observable latestFeaturePlanFetchDate: Date;

    constructor(globalContext: AuthenticatedGlobalContextValue) {
        super(globalContext, Account);
    }

    @action
    setIsFeaturePlanLoading(isLoading: boolean) {
        this.isFeaturePlanLoading = isLoading;
    }

    @action
    setHasLoadedFeaturePlan(hasLoaded: boolean) {
        this.hasLoadedFeaturePlan = hasLoaded;
    }

    @action
    setLastFeaturePlanFetchDate() {
        this.latestFeaturePlanFetchDate = new Date();
    }
}
